module.exports = __webpack_public_path__ + "img/tower_cooling.c15e0c0a.svg";